module.exports = __webpack_public_path__ + "src/components/Feedback/verified-protection.svg?e174015c";


//////////////////
// WEBPACK FOOTER
// ./src/components/Feedback/verified-protection.svg
// module id = 3091
// module chunks = 8